import React from 'react';
import { motion } from 'framer-motion';
import { CheckItem } from './ui/CheckItem';
import { MapaDePistaIcon, Programador12MesesIcon } from './ui/BonoIcons';
import type { BonoContent } from '../types/content';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
interface BonoItemProps {
  bono: BonoContent;
  index: number;
}
export function BonoItem({
  bono,
  index
}: BonoItemProps) {
  const isIconCard = Boolean(bono.icon);
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.4,
    ease: easeOut,
    delay: index % 4 * 0.05
  }} className={`flex flex-col rounded-2xl border bg-mp-card p-6 ${bono.premiumOnly ? 'border-mp-lime/40' : 'border-mp-border'}`} data-id="element-29" data-mp="1zan3ek86mbdm">
      {isIconCard && <div className="mb-5 flex h-28 items-center justify-center rounded-xl border border-mp-border bg-mp-dark" data-id="element-30" data-mp="3jmb0l4w705vx">
          {bono.icon === 'mapaDePista' && <MapaDePistaIcon className="h-14 w-14 text-mp-lime" data-id="element-31" data-mp="7vgj8t7ds9ng" />}
          {bono.icon === 'programador12Meses' && <Programador12MesesIcon className="h-14 w-14 text-mp-lime" data-id="element-32" data-mp="2wm1lul5gr4x" />}
        </div>}

      <div className="flex items-center justify-between gap-2" data-id="element-33" data-mp="gnqv0exxcn6t">
        <span className={`rounded-full border border-mp-lime/40 bg-mp-lime/5 uppercase text-mp-lime font-heading tracking-wide ${isIconCard ? 'px-2.5 py-1 text-[10px]' : 'px-3.5 py-1.5 text-xs'}`} data-id="element-34" data-mp="cngon167zurf">
          {bono.tag}
        </span>
        {bono.premiumOnly && <span className="font-heading text-[10px] uppercase tracking-wide text-mp-electric" data-id="element-35" data-mp="3u47z15h9zxdc">Solo Kit</span>}
      </div>

      <h3 className={`mt-3 font-heading uppercase leading-snug text-mp-white ${isIconCard ? 'text-lg' : 'text-xl'}`} data-id="element-36" data-mp="3p3u2okp1ebv5">
        {bono.title}
      </h3>

      <p className="mt-2 text-sm leading-relaxed text-mp-gray" data-id="element-37" data-mp="14empxkxofyia">{bono.oneLiner}</p>

      {bono.bullets && <ul className="mt-4 space-y-2" data-id="element-38" data-mp="21rnfs94xc9b">
          {bono.bullets.map(bullet => <CheckItem key={bullet} data-id="element-39" data-mp="6zt6id6k9bks">{bullet}</CheckItem>)}
        </ul>}

      {bono.value && <p className="mt-4 text-xs uppercase tracking-wide text-mp-gray/70" data-id="element-40" data-mp="b14yuqgtkawo">Valor: {bono.value}</p>}
      {bono.note && <p className="mt-2 text-xs leading-relaxed text-mp-gray/70" data-id="element-41" data-mp="g0zpcswomyh7">{bono.note}</p>}
    </motion.div>;
}